import React from 'react';

import { PageSidebar, PageTitle } from '../../../components';

import { FaCircleNotch } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const CareerSingle = () => {

  // Get the current location state
  const location = useLocation();  
  const positionSingle = location.state; 


  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Career Single'} page={'Career Single'} />

      <section className='event-single page-single'>

        <div className='event-info page-info'>

          {/* Job Image Section */} 
          <div className='image'>
            <img src={positionSingle.image} alt={positionSingle.title} />
          </div>

          <div className='content'>

            {/* Job Title */}
            <h3 className='main-heading'>{positionSingle.title}</h3>

            {/* Job Description Section */}
            {positionSingle.overviews.map((overview, index) => (
              <p key={index}>{overview}</p>
            ))}

            {/* Job Responsibilities Section */}
            <div className='sub-section'>
              <h3 className='sub-heading'>Job Responsibilities:</h3>
              <p>As a {positionSingle.title}, your responsibilities will include:</p>

              {/* List of Responsibilities */}
              <ul>
                {positionSingle.responsibilities.map((responsibility, index) => (
                  <li key={index}><FaCircleNotch className='icon' />{responsibility}</li>
                ))}
              </ul>
            </div>

            {/* Qualifications & Skills Section */}
            <div className='sub-section'>
              <h3 className='sub-heading'>Qualifications & Skills</h3>
              <p>To succeed in this role, you'll need:</p>

              {/* List of Qualifications */}
              <ul>
                {positionSingle.qualifications.map((qualification, index) => (
                  <li key={index}><FaCircleNotch className='icon' />{qualification}</li>
                ))}
              </ul>
            </div>

          </div> 
        </div> 

        {/* Sidebar Section */}
        <PageSidebar
          heading={'Career'}
          details={positionSingle.details}
          button={{ link: 'Career-Form', title: 'Apply Now' }}
        />

      </section>
    </> 
  );
}

export default CareerSingle;